/**
 * Параметр `?open=<сутність>:<UUID>` картки: запис, відкритий панеллю поверх картки господаря
 * (layout.md, розд. 7, правило 9; Б5-W1). Одна перевірка для маршруту й компонентів: пошук
 * без суворого маршруту (`useSearch({ strict: false })`) віддає значення з адреси без перевірки.
 */
const OPEN = /^[a-z][a-z0-9_]{0,62}:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Дія, з якою відкрито картку (`?act=pay` — «+ платіж» у шапці картки рахунку, Б5-W1): вкладка, що
 * відкриває панель, вмикається сама й відкриває крок; після цього параметр зникає з адреси.
 */
export const actParamOf = (value: unknown): 'pay' | undefined =>
  value === 'pay' ? value : undefined;

/**
 * Повна картка запису з `open: 'panel'` (`?full=1`, «Відкрити повністю»; metadata-ui.md, розд. 3): без
 * параметра такий запис з будь-якої точки входу відкривається панеллю на картці господаря.
 */
export const fullParamOf = (value: unknown): true | undefined =>
  value === '1' || value === 1 || value === true ? true : undefined;

/** Значення параметра, лише якщо воно правильної форми; інакше — `undefined`. */
export const openParamOf = (value: unknown): string | undefined =>
  typeof value === 'string' && OPEN.test(value) ? value : undefined;
